<!--
 This Component is a bit a hack, it injects the active campaign form and mounts it.
 The form injected should be also styled with our application css so we need to strip out the custom active campaign css.
 -->
<template>
    <div :style="rootStyle" :class="divClass"/>
</template>
<script>
    const WAIT_TIMEOUT = 800;

    export default {
        props: {
            src: {
                type: String,
                required: true,
            },
            divClass: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                isReady: false,
            };
        },
        computed: {
            rootStyle() {
                return {
                    display: this.isReady ? 'block' : 'none',
                };
            },
        },
        methods: {
            injectScript(src) {
                const script = document.createElement('script');
                script.onload = this.onScriptLoaded;
                script.src = src;
                document.getElementsByTagName('head')[0].appendChild(script);
            },
            waitCSSNodeInjection() {
                const wait = (callback) => {
                    const cssNode = this.$el.firstChild;

                    if (cssNode) {
                        callback(cssNode);
                    } else {
                        setTimeout(function() {
                            wait(callback);
                        }, WAIT_TIMEOUT);
                    }
                };

                return new Promise(resolve => wait(resolve));
            },
            onScriptLoaded() {
                // wait until the div will be filled with the active campaign css node
                this.waitCSSNodeInjection().then(cssNode => {
                    // remove the user defined css
                    if (cssNode.tagName === 'STYLE') {
                        cssNode.parentNode.removeChild(cssNode);
                    }

                    this.isReady = true;
                });
            },
        },
        mounted() {
            this.injectScript(this.src);
        },
    };
</script>
